import { isAnyFilterSelected } from '@/app/helpers/searchparams';
import React from 'react';
import { FilterOptionKeys, FilterOptions, SearchParams } from '@mybestbrands/types';
import { SelectedFiltersContainerWrapper } from '@/app/ui/components/filters/SelectedFiltersContainerWrapper';
import { useTranslation } from 'next-i18next';

interface Props {
  facets: FilterOptions | null;
  searchParams: SearchParams;
  localePath: string;
  excludedFilters: FilterOptionKeys[];
}

export function SelectedFiltersContainerMobile({ facets, searchParams, localePath, excludedFilters }: Props) {
  const anyFilterSelected = isAnyFilterSelected(searchParams, excludedFilters);
  const { t } = useTranslation(['filters']);

  if (!anyFilterSelected) return null;

  return (
    <>
      <div className="mb-2">
        <strong>{t('FILTER_BY')}</strong>
      </div>
      <SelectedFiltersContainerWrapper
        facets={facets}
        searchParams={searchParams}
        localePath={localePath}
        excludedFilters={excludedFilters}
      />
    </>
  );
}
